import BaseService from '@/api/services/index'
import Account from '@/api/models/Account'
import MessageDto from '@/api/dto/MessageDto'
import UrlDto from '@/api/dto/UrlDto'

export default class AccountService extends BaseService {
    public async getAccounts (): Promise<Array<Account>> {
        return this.api.get<never, Array<Account>>(
            this.getUrl('get_accounts')
        )
    }

    public async updateAccount (account: Account): Promise<MessageDto> {
        return this.api.patch<Account, MessageDto>(
            this.getUrl('update_account', { id: account.id }),
            account
        )
    }

    public async createAccount (account: Account): Promise<Account> {
        return this.api.put<Account, Account>(
            this.getUrl('account_create'),
            account
        )
    }

    public async getRefreshTokenUrl (accountId: number): Promise<UrlDto> {
        return this.api.get<never, UrlDto>(
            this.getUrl('get_refresh_token_url', { accountId: accountId })
        )
    }
}
